export class Image {
    id: string;
    merchantId: string;
    isCategory: boolean;
    cloverDataId: string;
    cloverDataName: string;
    imageData: string;
    s3ContainerKey: string;
  }
